
export default {
    apiBase: 'https://www.onestockhome.com',
    clientId: 'rJHUNTUIID643qwHqTFY8bD6VbdYn7xVFJXZ8AXimic',
    apiWSBase: 'wss://www.onestockhome.com/cable',
    erpBase: 'https://catman.onestockhome.com'
}

